const normalizeHeader = (value) => String(value ?? '')
  .replace(/^\uFEFF/, '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .trim()
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '_')
  .replace(/^_+|_+$/g, '');

const parseLine = (line, delimiter) => {
  const values = [];
  let value = '';
  let quoted = false;
  for (let index = 0; index < line.length; index += 1) {
    const character = line[index];
    if (character === '"') {
      if (quoted && line[index + 1] === '"') {
        value += '"';
        index += 1;
      } else {
        quoted = !quoted;
      }
    } else if (character === delimiter && !quoted) {
      values.push(value.trim());
      value = '';
    } else {
      value += character;
    }
  }
  if (quoted) throw new Error('Hay una comilla sin cerrar en el archivo CSV.');
  values.push(value.trim());
  return values;
};

const firstValue = (row, ...keys) => {
  const key = keys.find((candidate) => row[candidate] !== undefined);
  return key ? String(row[key] ?? '').trim() : '';
};

const normalizePosition = (value) => {
  const normalized = normalizeHeader(value);
  const positions = {
    ajustador: 'adjustador',
    adjuster: 'adjustador',
    maquinista: 'maquinista',
    machinist: 'maquinista',
    recibidor: 'recibidor',
    receiver: 'recibidor',
    jefe: 'jefe_grupo',
    jefe_grupo: 'jefe_grupo',
    jefe_de_grupo: 'jefe_grupo',
    group_leader: 'jefe_grupo',
    otro: 'otro',
    other: 'otro',
  };
  return value ? (positions[normalized] || normalized) : null;
};

const normalizeBoolean = (value) => {
  const normalized = normalizeHeader(value);
  if (!normalized) return undefined;
  if (['1', 'true', 'si', 'yes', 'activo'].includes(normalized)) return true;
  if (['0', 'false', 'no', 'inactivo'].includes(normalized)) return false;
  return value;
};

export const parseEmployeeCsv = (input) => {
  const lines = String(input ?? '').replace(/\r/g, '').split('\n')
    .map((line, index) => ({ line, sourceRow: index + 1 }))
    .filter(({ line }) => line.trim() !== '');
  if (lines.length < 2) {
    throw new Error('El CSV debe incluir encabezados y al menos un empleado.');
  }

  const delimiter = lines[0].line.includes('\t')
    ? '\t'
    : (lines[0].line.includes(';') && !lines[0].line.includes(',') ? ';' : ',');
  const headers = parseLine(lines[0].line, delimiter).map(normalizeHeader);
  if (!headers.includes('employee_number') && !headers.includes('numero_empleado') && !headers.includes('numero')) {
    throw new Error('Falta la columna employee_number o numero_empleado.');
  }
  if (!headers.includes('name') && !headers.includes('nombre')) {
    throw new Error('Falta la columna name o nombre.');
  }

  const rows = lines.slice(1).map(({ line, sourceRow }) => {
    const values = parseLine(line, delimiter);
    const raw = {};
    headers.forEach((header, index) => { raw[header] = values[index] ?? ''; });
    const password = firstValue(raw, 'password', 'contrasena');
    const hasAccess = normalizeBoolean(firstValue(raw, 'has_access', 'acceso'));
    const active = normalizeBoolean(firstValue(raw, 'active', 'activo'));

    return {
      source_row: sourceRow,
      employee_number: firstValue(raw, 'employee_number', 'numero_empleado', 'numero', 'empleado'),
      name: firstValue(raw, 'name', 'nombre'),
      position: normalizePosition(firstValue(raw, 'position', 'puesto')),
      ...(active === undefined ? {} : { active }),
      ...(password ? { password } : {}),
      ...(hasAccess === undefined ? {} : { has_access: hasAccess }),
    };
  });

  if (rows.length > 2000) throw new Error('El archivo no puede contener más de 2,000 empleados.');
  return rows;
};
